/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-30 14:36:27
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-10-16 14:27:55
 * @FilePath: /goldenSalesMobile/src/api/system.js
 * @Description: 系统参数相关接口
 */
import { requestOfGet, requestOfPost } from "../utils/http"
const baseUrl = 'wechath5/zh-cn/v1/app/'

// 获取系统参数
export function getSystemParams() {
  return requestOfGet(`${baseUrl}enum`)
}

// 获取图片Token
export function getImageToken() {
  return requestOfGet(`${baseUrl}oss-token/0`)
}

// 获取收钱吧配置
export function getShouqianbaConfig(param) {
  return requestOfGet(`${baseUrl}shouqianba`, param)
}

// 佣金提现
export function postCommisionWithdraw(param) {
  return requestOfPost(`${baseUrl}wechat/withdraw`, param)
}

// 获取商户banner
export function getStoreBanner() {
  return requestOfGet(`${baseUrl}advertisement`)
}
